<template>
    <div>
        <Navbar />
        <PageBanner pageTitle="Impressum"  />
        <Imprint />
        <Overview />
        <Footer class="margin-zero" />
    </div>
</template>

<script>
import Navbar from '../Layouts/NavbarStyleTwo'
import PageBanner from '../Common/PageBanner'
import Imprint from '../TermsService/Imprint'
import Overview from '../Common/Overview'
import Footer from '../Layouts/Footer'

export default {
    name: 'ImprintPage',
    components: {
        Navbar,
        PageBanner,
        Imprint,
        Overview,
        Footer,
    }
}
</script>